import { render, staticRenderFns } from "./category-details.vue?vue&type=template&id=93952884&scoped=true&"
import script from "./category-details.vue?vue&type=script&lang=js&"
export * from "./category-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93952884",
  null
  
)

export default component.exports